'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TYPING_INDICATOR_TIMEOUT_MS = exports.TYPING_INDICATOR_TIMEOUT_MS = 5500;